// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RowVariant_wrap__YdZnS","link":"RowVariant_link__qkI9Q","empty":"RowVariant_empty__U9Ude"};